export default "__VITE_ASSET__BaPX8sQ8__"